import { NetworkStrength1AlertIcon } from './NetworkStrength1AlertIcon';

/**
 * author: Simran
 * id 9C2C41A2-7BA9-46C3-B017-941C7B2C2E60
 * name network-strength-1-alert
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/network-strength-1-alert.svg
 * tags
 * - Cellphone / Phone 
 * - Alert / Error 
 */
export const NetworkStrength1WarningIcon = NetworkStrength1AlertIcon;
export default NetworkStrength1WarningIcon